export default __webpack_public_path__ + "static/media/body-section-spinals.50648911.png";